import sessionData from "./data.js";

function get(sessionId: string) {
	return sessionData.has(sessionId);
}

export { get };

export default get;
